module.exports = __webpack_public_path__ + "static/media/APP_TimeMagician_152x174_3.d487f6af.png";